import { Button, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SelectInput from "../../../../components/Select/SelectInput";
import { Context } from "../../../../context/context";
import { getPermissions } from "../../../../services/permission-service";
import { editUser, getUserById } from "../../../../services/user-service";
import {
  createUserZone,
  updateUserZone,
  deleteUserZone,
  getZones,
} from "../../../../services/zone-service";
import cpfMask from "../../../../utils/cpf-mask";

import "./UserById.scss";

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 100,
    },
  },
};

export default function UserById() {
  const { sidebar } = useContext(Context);
  const { id } = useParams();
  const accessToken = localStorage.getItem("token");
  const [userData, setUserData] = useState(null);
  const [permissionList, setPermissionList] = useState([]);
  const [selectedPermission, setSelectedPermission] = useState();
  const [zones, setZones] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);

  async function getUserData() {
    const result = await getUserById(accessToken, id);
    setSelectedPermission(result.permission_id);
    setUserData(result);
    setSelectedZones(result.zones.map((zon) => zon.id));
  }

  async function getUserZones() {
    const result = await getZones(accessToken);
    setZones(result);
  }

  async function getPermissionsData() {
    const result = await getPermissions(accessToken);

    setPermissionList(result);
  }

  function formatCpf(cpf) {
    return cpfMask(cpf);
  }

  function formatValue(value) {
    if (typeof value === "string") {
      return value.replace(",", ".");
    }

    return String(value);
  }

  function handleChanges(e) {
    setUserData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const data = {
      name: userData.name,
      id: userData.id,
      email: userData.email,
      k: userData.k,
      k_arla: userData.k_arla,
      comission: userData.comission,
      comission_arla: userData.comission_arla,
      comission_diesel: userData.comission_diesel,
      permission_id: selectedPermission,
      dtCreate: new Date(userData.dtCreate),
    };

    const userZones = userData.zones.map((z) => z.id);
    console.log(selectedZones);
    try {
      await updateUserZone(accessToken, {
        userId: data.id,
        zoneId: selectedZones,
      });
    

      const result = await editUser(accessToken, data);

      if (result.status === 200) alert("Usuário atualizado com sucesso.");
    } catch (error) {
      alert("Algo deu errado. Tente novamente");
    }
  }

  useEffect(() => {
    getUserData();
    getPermissionsData();
    getUserZones();
  }, []);

  return (
    <main className={sidebar ? "container" : "container-full"}>
      <h1>Editar Usuário</h1>
      {userData && (
        <form onSubmit={handleSubmit} className="inputs-container">
          <div className="inputs-container__column">
            <TextField
              fullWidth
              label="Nome"
              name="name"
              value={userData.name}
              onChange={handleChanges}
            />

            <TextField
              fullWidth
              label="Cpf"
              name="cpf"
              value={formatCpf(userData.cpf)}
              disabled
            />

            <TextField
              fullWidth
              label="Email"
              name="email"
              value={userData.email ? userData.email : "Não definido."}
              onChange={handleChanges}
            />
          </div>

          <div className="inputs-container__column">
            <TextField
              fullWidth
              label="K"
              name="k"
              type="number"
              value={userData.k ? formatValue(userData.k) : "Não definido."}
              onChange={handleChanges}
              inputProps={{
                autoComplete: "off",
                step: "0.0001",
              }}
            />

            <TextField
              fullWidth
              label="K Arla"
              name="k_arla"
              type="number"
              value={
                userData.k_arla ? formatValue(userData.k_arla) : "Não definido"
              }
              onChange={handleChanges}
              inputProps={{
                autoComplete: "off",
                step: "0.0001",
              }}
            />

            <TextField
              fullWidth
              label="Comissão Diesel"
              name="comission_diesel"
              type="number"
              value={userData.comission_diesel}
              onChange={handleChanges}
              inputProps={{
                autoComplete: "off",
                step: "0.0001",
              }}
            />

            <TextField
              fullWidth
              label="Comissão Arla"
              name="comission_arla"
              type="number"
              value={userData.comission_arla}
              onChange={handleChanges}
              inputProps={{
                autoComplete: "off",
                step: "0.0001",
              }}
            />
          </div>

          <div className="inputs-container__column">
            <SelectInput
              label="Permissão"
              style={{ width: "80%" }}
              value={selectedPermission}
              name="permission_id"
              setValue={setSelectedPermission}
              selectValues={permissionList}
            />
            <div className="form-container" style={{ width: "80%" }}>
              <FormControl>
                <InputLabel id="demo-multiple-checkboxx-label">
                  Zonas
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkboxx-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={selectedZones}
                  onChange={(e) => {
                    setSelectedZones(e.target.value);
                  }}
                  input={<OutlinedInput label="Zonas" />}
                  renderValue={(selected) => selected.join(", ")}
                  MenuProps={MenuProps}
                >
                  {zones.length > 0 &&
                    zones.map((item) => (
                      <MenuItem key={item.name} value={item.id}>
                        <Checkbox
                          checked={selectedZones.indexOf(item.id) > -1}
                        />
                        <ListItemText primary={item.name} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
          </div>

          <div>
            <Button
              className="save-btn"
              type="submit"
              size="medium"
              variant="contained"
            >
              Salvar
            </Button>
          </div>
        </form>
      )}
    </main>
  );
}
